import { authApi } from "./api"

// POST : Save Survey Form
export const saveSurveyApi = (formData, userId) =>
    authApi.post(
        `/survey/${userId}`, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    )

// // GET: Survey Form 신청 여부 조회
// export const checkSurveyFormApi = () => authApi.get(`/survey/form/check`)

// GET: Survey Form
export const getSurveyFormApi = (userId) => authApi.get(`/survey/form/${userId}`)

// GET: Get Test Status
export const getTestCodeAndCompletionApi = (userId) => authApi.get(`/survey/test/${userId}`)


// POST: Save Test Completion 검사완료 처리
export const saveTestCompletionApi = (data) => authApi.post(`/survey/test/completion`, data)

// GET: Get Report Datas
export const getReportDatasApi = (userId) => authApi.get(`/survey/report/${userId}`)
